// extracted by mini-css-extract-plugin
module.exports = {"cookie-consent-body":"Cookie-module__cookie-consent-body___27jAt","cookie-container":"Cookie-module__cookie-container___104HI"};